// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2U9DV","right":"Footer_right__qXUzV","buttons":"Footer_buttons__22oYe"};